import {KTIcon} from '../../../../_metronic/helpers'

const ApiModalHeader = ({setOpenAPIModal, user}) => {
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>{user?.partner_id ? 'Edit' : 'Enable'} API Access For User</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setOpenAPIModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>

    </div>
  )
}

export {ApiModalHeader}
